import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

// Credenciais do projeto e-MSS Supabase
// Anon key é pública por design — segurança é feita via RLS no banco.
const SUPABASE_URL = 'https://vxandpltgyowfdtbkcat.supabase.co';
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ4YW5kcGx0Z3lvd2ZkdGJrY2F0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzUzMDEyMDcsImV4cCI6MjA5MDg3NzIwN30.7_rWC_98IE4rbSyD2BoIwqLnEtAEWxZgcRpyn__e__0';

// Permite sobrescrever via env (produção com variáveis de ambiente diferentes)
const supabaseUrl = (import.meta.env.VITE_SUPABASE_URL as string) || SUPABASE_URL;
const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY as string) || SUPABASE_ANON_KEY;

if (import.meta.env.DEV) {
  console.log('[Supabase] URL:', supabaseUrl);
  console.log('[Supabase] AnonKey presente:', supabaseAnonKey?.length > 10 ? '✅ SIM' : '❌ NÃO');
}

/**
 * Cliente Supabase tipado com o schema do banco.
 * Responsabilidade: Auth (Google OAuth), Realtime, leituras via RLS (anon key).
 * Para operações privilegiadas, use os endpoints Serverless /api/*.
 */
export const supabase = createClient<Database>(
  supabaseUrl,
  supabaseAnonKey,
  {
    global: {
      headers: {
        // Garante que o apikey header seja sempre enviado, mesmo se o SDK não injetar
        'apikey': supabaseAnonKey,
      },
    },
  }
);
